import { CloseOutlined} from "@ant-design/icons";
import { Form, Input } from "antd";
import React, { useEffect, useState } from "react";

function FormWithRows({
  setRowState,
  rowState,
  setOptionsObject,
  optionsObject,
  initualData,
  
}) {
  const [rows, setRows] = useState(
    initualData
      ? initualData?.map((item) => {
          return {
            fullName: item?.fullName,
            position: item?.position,
            phoneNumber: item?.phoneNumber,
          };
        })
      : []
  );

  const [newRow, setNewRow] = useState({
    fullName: "",
    position: "",
    phoneNumber: "",
  });



  useEffect(()=>{
    if(rowState && rows.length !== 0){
      setRowState(false);
      setRows([]);
      setOptionsObject({
        ...optionsObject,
        alertPhoneNumbers: [],
      });
    }
  },[rowState,optionsObject])
  const addRow = () => {
    setRows([...rows, { ...newRow }]);
    setOptionsObject({
      ...optionsObject,
      alertPhoneNumbers: [...rows, { ...newRow }],
    });
    form.resetFields();
    setNewRow({ fullName: "", position: "", phoneNumber: "" });
  };

  const deleteRow = (index) => {
    const updatedRows = [...rows];
    updatedRows.splice(index, 1);
    setRows(updatedRows);
    setOptionsObject({ ...optionsObject, alertPhoneNumbers: updatedRows });
  };

  const handleChange = (e, index) => {
    const { name, value } = e.target;
    const updatedRows = [...rows];
    updatedRows[index] = { ...updatedRows[index], [name]: value };
    setRows(updatedRows);
  };

  const [form] = Form.useForm();

  return (
    <div className="flex flex-col gap-3 w-full">
      {rows?.length >= 1 &&
        rows.map((row, index) => (
          <div className="flex flex-row gap-2" key={index}>
            <Input autoComplete="nope"
              required
              className="inner-box-hover py-2"
              disabled
              type="text"
              name="fullName"
              placeholder="نام"
              value={row.fullName}
              onChange={(e) => handleChange(e, index)}
            />
            <Input autoComplete="nope"
              className="inner-box-hover py-2"
              disabled
              type="text"
              placeholder="سمت"
              name="position"
              value={row.position}
              onChange={(e) => handleChange(e, index)}
            />
            <Input autoComplete="nope"
              className="inner-box-hover py-2"
              disabled
              type="number"
              name="phoneNumber"
              value={row.phoneNumber}
              onChange={(e) => handleChange(e, index)}
              placeholder="شماره همراه"
            />
            <button
              className="text-red-600 circle-neo px-3 pt-1"
              onClick={() => deleteRow(index)}
            >
              <CloseOutlined />
            </button>
          </div>
        ))}

      {rows?.length <= 4 && (
        <Form
        autoComplete="nope"

          form={form}
          name="wrap"
          onFinish={addRow}
          className="flex flex-row gap-2 !w-full"
        >
          <Form.Item
            name="fullName"
            className="w-full"
            rules={[{ required: true, message: "لطفا نام را وارد کنید" }]}
          >
            <Input autoComplete="nope"
              className="inner-box-hover py-2"
              type="text"
              name="fullName"
              value={newRow.fullName}
              onChange={(e) =>
                setNewRow({ ...newRow, fullName: e.target.value })
              }
              placeholder="نام"
            />
          </Form.Item>
          <Form.Item
            className="w-full"
            name="position"
            rules={[{ required: true, message: "لطفا سمت را وارد کنید" }]}
          >
            <Input autoComplete="nope"
              className="inner-box-hover py-2"
              type="text"
              name="position"
              value={newRow.position}
              onChange={(e) =>
                setNewRow({ ...newRow, position: e.target.value })
              }
              placeholder="سمت"
            />
          </Form.Item>
          <Form.Item
            className="w-full"
            type="number"
            name="phoneNumber"
            rules={[
              { required: true, message: "لطفا شماره همراه را وارد کنید" },
              { min: 11, message: "شماره همراه نمیتواند از 11 رقم کمتر باشد" },
              { max: 11, message: "شماره همراه نمیتواند از 11 رقم بیشتر باشد" },
              { pattern: /(09)\d{9}/, message: "" },
            ]}
          >
            <Input autoComplete="nope"
              className="inner-box-hover py-2"
              type="number"
              name="phoneNumber"
              value={newRow.phoneNumber}
              onChange={(e) =>
                setNewRow({ ...newRow, phoneNumber: e.target.value })
              }
              placeholder="شماره همراه"
            />
          </Form.Item>
          <Form.Item className="flex flex-row" htmlFor="submit">
            <button
              className="circle-neo px-3 pt-[8px] pb-[5px] text-green-700 whitespace-nowrap font-bold !rounded-2xl"
              type="submit"
            >
              + ثبت
            </button>
          </Form.Item>
        </Form>
      )}
    </div>
  );
}

export default FormWithRows;
